import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import './styles.less';

const renderIcon = (url) => {
    if (url) {
        return (
            <a href={url}>
                <Icon className="play-overlay__icon" icon="play-overlay" />
            </a>
        );
    } else {
        return <Icon className="play-overlay__icon" icon="play-overlay" />;
    }
};

const PlayOverlay = (props) => {
    return (
        <div
            className={classNames(
                'play-overlay',
                ({[`play-overlay--${props.position}`]: props.position}),
                props.className || null
            )}
        >
            {renderIcon(props.url)}
        </div>
    );
};

PlayOverlay.propTypes = {
    position: PropTypes.oneOf(['top-left', 'center', 'bottom-left']).isRequired,
    className: PropTypes.string,
    url: PropTypes.string
};

PlayOverlay.defaultProps = {
    className: undefined,
    url: undefined
};

export default PlayOverlay;
